import React from 'react';
import { NeoBadge, NeoButton } from '../../../../../components/Common';
import { formatCurrency } from '../../../../../utils/format';
import { FINANCIAL_STATUS, FINANCIAL_SOURCES } from '../../../../../constants/financial';

const statusConfig = {
    [FINANCIAL_STATUS.PENDING]: { color: 'warning', label: 'Pendente' },
    [FINANCIAL_STATUS.PAID]:    { color: 'success', label: 'Pago' },
    [FINANCIAL_STATUS.OVERDUE]: { color: 'danger',  label: 'Atrasado' },
    [FINANCIAL_STATUS.CANCELED]:{ color: 'secondary',label: 'Cancelado' },
    'REFUNDED':                  { color: 'info',    label: 'Reembolsado' },
};

const StatusBadgeFinancial = ({ row }) => {
    if (row.status === FINANCIAL_STATUS.PENDING && row.sourceType === FINANCIAL_SOURCES.ACQUIRER) {
        return <NeoBadge color="success" pill>Pago</NeoBadge>;
    }
    const { color, label } = statusConfig[row.status] || { color: 'secondary', label: row.status };
    return <NeoBadge color={color} pill>{label}</NeoBadge>;
};

export const getFinancialColumns = ({ formatDate, onViewSale }) => [
    {
        label: 'Categoria / Descrição',
        key: 'categoryName',
        flex: '2',
        minWidth: 160,
        render: (row) => (
            <div style={{ minWidth: 0 }}>
                <span className="neo-table-contact-name fw-bold text-dark">{row.categoryName || 'Lançamento'}</span>
                <small className="neo-table-cell-truncate text-muted font-size-11">
                    {row.isGroup ? "Venda Condensada" : (row.description || row.notes)}
                </small>
            </div>
        )
    },
    {
        label: 'Origem',
        key: 'entityName',
        flex: '1.5',
        minWidth: 110,
        render: (row) => (
            <div style={{ minWidth: 0 }}>
                <span className="neo-table-cell-truncate fw-semibold text-muted font-size-11">
                    {row.sourceType === FINANCIAL_SOURCES.MEMBER ? 'Aluno' : row.sourceType || 'Outro'}
                </span>
                <span className="neo-table-cell-truncate text-dark font-size-13">{row.entityName || '—'}</span>
            </div>
        )
    },
    {
        label: 'Vencimento',
        key: 'dueDate',
        width: '115px',
        align: 'center',
        render: (row) => (
            <span className={`fw-semibold font-size-13 ${row.status === FINANCIAL_STATUS.OVERDUE ? 'text-danger' : 'text-dark'}`}>
                {formatDate(row.dueDate)}
            </span>
        )
    },
    {
        label: 'Pagamento',
        key: 'paymentDate',
        width: '130px',
        align: 'center',
        render: (row) => (
            <div className="d-flex flex-column align-items-center">
                <span className="text-dark font-size-13">{row.paymentDate ? formatDate(row.paymentDate) : '—'}</span>
                {row.paymentMethod && <small className="text-muted font-size-11">{row.paymentMethod}</small>}
            </div>
        )
    },
    {
        label: 'Valor',
        key: 'netAmount',
        width: '110px',
        align: 'right',
        render: (row) => (
            <span className="fw-bold text-primary font-size-13">
                {formatCurrency(row.netAmount)}
            </span>
        )
    },
    {
        label: 'Vendedor',
        key: 'employeeName',
        flex: '1',
        minWidth: 90,
        render: (row) => (
            <span className="neo-table-cell-truncate text-muted font-size-12">
                {row.employeeName || '—'}
            </span>
        )
    },
    {
        label: 'Status',
        key: 'status',
        width: '115px',
        align: 'center',
        render: (row) => <StatusBadgeFinancial row={row} />
    },
    {
        label: '',
        key: 'actions',
        width: '52px',
        align: 'center',
        overflow: 'visible',
        render: (row) => row.idSale ? (
            <NeoButton
                variant="soft-primary"
                size="sm"
                square
                icon="mdi-eye-outline"
                title="Ver Detalhes da Venda"
                onClick={(e) => { e.stopPropagation(); onViewSale?.(row); }}
            />
        ) : null
    }
];

export const getInstallmentColumns = ({ formatDate }) => [
    {
        label: 'Parcela',
        key: 'installment',
        width: '80px',
        align: 'center',
        render: (row) => (
            <span className="fw-semibold text-dark font-size-13">
                {row.currentInstallment ? `${row.currentInstallment}/${row.totalInstallments || 1}` : '—'}
            </span>
        )
    },
    {
        label: 'Valor',
        key: 'netAmount',
        width: '110px',
        align: 'right',
        render: (row) => (
            <span className="fw-bold text-primary font-size-13">
                {formatCurrency(row.netAmount || row.grossAmount)}
            </span>
        )
    },
    {
        label: 'Vencimento',
        key: 'dueDate',
        width: '115px',
        align: 'center',
        render: (row) => (
            <span className={`fw-semibold font-size-13 ${row.status === FINANCIAL_STATUS.OVERDUE ? 'text-danger' : 'text-dark'}`}>
                {formatDate(row.dueDate)}
            </span>
        )
    },
    {
        label: 'Pagamento',
        key: 'paymentDate',
        width: '115px',
        align: 'center',
        render: (row) => (
            <span className="text-muted font-size-13">
                {row.paymentDate ? formatDate(row.paymentDate) : '—'}
            </span>
        )
    },
    {
        label: 'Método / Origem',
        key: 'method',
        flex: '1',
        minWidth: 100,
        render: (row) => (
            <div style={{ minWidth: 0 }}>
                <span className="neo-table-cell-truncate font-size-12 text-muted">{row.paymentMethod || '—'}</span>
                <span className="neo-table-cell-truncate font-size-11 text-muted">
                    {row.sourceType === FINANCIAL_SOURCES.MEMBER ? 'Aluno' : row.sourceType || 'Outro'}
                </span>
            </div>
        )
    },
    {
        label: 'Status',
        key: 'status',
        width: '115px',
        align: 'center',
        render: (row) => <StatusBadgeFinancial row={row} />
    }
];
